module.exports = __webpack_public_path__ + "static/media/KIDNordicDanish.f7f6e36c.pdf";